import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  href,
  onClick
}: ButtonProps) {
  const sharedClassName = `
    inline-flex items-center justify-center text-center
    bg-blood text-white font-sans font-semibold text-sm md:text-base
    uppercase tracking-widest py-4 px-8 rounded-[2px]
    transition-colors duration-300 shadow-[0_0_20px_rgba(184,20,28,0.2)]
    hover:shadow-[0_0_30px_rgba(184,20,28,0.4)]
    cursor-pointer no-underline
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const motionProps = {
    whileHover: {
      scale: 1.02,
      backgroundColor: '#A50F15'
    },
    whileTap: {
      scale: 0.98
    }
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} {...motionProps} className={sharedClassName} data-id="element-19">
        {children}
      </motion.a>;
  }
  return <motion.button type="button" onClick={onClick} {...motionProps} className={sharedClassName} data-id="element-20">
      {children}
    </motion.button>;
}